import { Button } from '@mui/material';
import { useState } from 'react';

import { IconAttachFileMS } from '../../../../../../constants/icons';
import {
  DialogActionsBox,
  DialogContainer,
  DialogTextTypography,
  DialogTitleTypography,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from '../styles';

interface ApproveContractDialogProps {
  name: string;
  document: string;
  docLoading: boolean;
  disabled: boolean;
  handleApprove: () => Promise<void>;
}

/**
 * Confirmação da aprovação do contrato assinado. Diferente da aprovação de um
 * documento avulso, esta ação conclui o credenciamento e sai da tela — por isso
 * não pode ser um clique só. Espelha o RejectDialog, que já pedia confirmação
 * no caminho da rejeição.
 */
export function ApproveContractDialog({
  name,
  document,
  docLoading,
  disabled,
  handleApprove,
}: ApproveContractDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    handleApprove().then(() => handleClose());
  };

  return (
    <>
      <Button
        disabled={docLoading || disabled}
        sx={{ maxWidth: '120px', height: '40px' }}
        onClick={handleOpen}
      >
        aprovar
      </Button>
      <StyledDialog open={open} onClose={handleClose}>
        <DialogContainer>
          <DialogTitleTypography>Aprovar {name}</DialogTitleTypography>
          {document && (
            <TextTypography sx={{ justifyContent: 'center' }}>
              {IconAttachFileMS}
              {document}
            </TextTypography>
          )}
          <DialogTextTypography>
            Isso conclui o credenciamento da empresa e não pode ser desfeito por
            esta tela.
          </DialogTextTypography>
          <DialogActionsBox my={2.5}>
            <OutlinedButton
              sx={{ maxWidth: '200px', width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={handleClose}
            >
              cancelar
            </OutlinedButton>
            <Button
              sx={{ width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={handleConfirm}
            >
              aprovar
            </Button>
          </DialogActionsBox>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
